<template>
  <div class="overlay" @click="$emit('close')">
    <div class="dialog" @click.stop>
      <h3 class="title">{{ title }}</h3>
      <p v-if="hint" class="hint">{{ hint }}</p>
      <textarea
        ref="ta"
        v-model="texto"
        :rows="rows"
        :placeholder="placeholder"
        class="inp"
      ></textarea>
      <div class="pie">
        <span class="contador" :class="{ corto: falta > 0 }">
          {{ falta > 0 ? "Faltan " + falta + " caracteres" : "&nbsp;" }}
        </span>
      </div>
      <p v-if="error" class="error">{{ error }}</p>
      <div class="acciones">
        <button class="btn cancel" @click="$emit('close')">Cancelar</button>
        <button
          class="btn confirm"
          :disabled="falta > 0 || busy"
          :style="{ background: falta > 0 || busy ? '#cbd5e1' : color }"
          @click="$emit('confirm', texto.trim())"
        >
          {{ busy ? "Guardando…" : confirmText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// Diálogo para las acciones que exigen un texto justificatorio: rechazo (RN-04),
// reapertura (RN-10), observaciones de CX y rechazo de evidencia (RN-15).
// El mínimo de caracteres se pasa por props y refleja el que valida el backend,
// de modo que el botón no se habilita hasta que la petición vaya a pasar.
export default {
  name: "PromptDialog",
  props: {
    title: { type: String, required: true },
    hint: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    confirmText: { type: String, default: "Confirmar" },
    color: { type: String, default: "#003ca5" },
    min: { type: Number, default: 10 },
    rows: { type: Number, default: 4 },
    busy: { type: Boolean, default: false },
    error: { type: String, default: "" },
  },
  emits: ["confirm", "close"],
  data() {
    return { texto: "" };
  },
  computed: {
    falta() {
      return Math.max(0, this.min - this.texto.trim().length);
    },
  },
  mounted() {
    this.$nextTick(() => this.$refs.ta && this.$refs.ta.focus());
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  inset: 0;
  z-index: 80;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(15, 23, 42, 0.45);
}
.dialog {
  width: 100%;
  max-width: 440px;
  background: var(--pt-card, #fff);
  color: var(--pt-text, #0f172a);
  border-radius: 16px;
  padding: 20px;
}
.title {
  font-size: 17px;
  font-weight: 700;
  margin: 0 0 6px;
}
.hint {
  font-size: 13px;
  color: var(--pt-dim);
  margin: 0 0 12px;
}
.inp {
  width: 100%;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 14px;
  border: 1px solid var(--pt-border);
  outline: none;
  background: var(--pt-card);
  color: var(--pt-text);
  box-sizing: border-box;
  font-family: inherit;
  resize: none;
}
.inp:focus {
  border-color: #003ca5;
}
.pie {
  min-height: 18px;
}
.contador {
  font-size: 11px;
  color: var(--pt-muted);
}
.contador.corto {
  color: #d97706;
}
.error {
  margin: 4px 0 0;
  font-size: 13px;
  color: #b91c1c;
}
.acciones {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 12px;
}
.btn {
  padding: 9px 18px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  border: 0;
  cursor: pointer;
  font-family: inherit;
}
.cancel {
  background: var(--pt-track);
  color: var(--pt-dim);
}
.confirm {
  color: #fff;
}
.confirm:disabled {
  cursor: not-allowed;
}
</style>
